export function useNavPopStateReload() {
  onMounted(() => {
    window.onpopstate = function () {
      location.reload()
    }
  })

  onUnmounted(() => {
    window.onpopstate = function () {
      // Remove location.reload()
    }
  })
}
